import type { Enum } from './enum.types';

export const CompetitionSex = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;
export type CompetitionSex = Enum<typeof CompetitionSex>;

export const CompetitionType = {
  CLUB: 'CLUB',
  ASSOCIATION: 'ASSOCIATION',
} as const;
export type CompetitionType = Enum<typeof CompetitionType>;
